export const DashboardTypes = {
    Asset: "Asset",
    Fund: "Fund",
    FundSeries: "FundSeries",
    Manager: "Manager",
    Market: "Market",
    Portfolio: "Portfolio"
};
export const AuxFilterType = {
    CalendarRange: "calendar-range",
    MultiSelect: "multi-select",
    MultiSlider: "multi-slider",
    PickList: "picklist"
};
